import { ErrorCode } from "../../enum/errorCode";
import { strings } from "../../localization";

// Definição de tipos
interface ContextMap {
	[key: string]: {
		patterns: Array<{
			url: string;
			code: string;
		}>;
		errorMessage: string;
	};
}

const { authentication, balanceInquiryRelease, biometry, password, payRegistration, signature, simulation } = strings.mappingErrorInterceptor;

/**
 * Mapeamento de contextos, padrões de URL e mensagens de erro
 */
export const ERROR_CONTEXT_MAP: ContextMap = {
	biometry: {
		patterns: [
			{ url: "/biometry", code: ErrorCode.ERR_BIOMETRY_001 },
			{ url: "/fraud-analysis/v1?productId=FGTS", code: ErrorCode.ERR_FRAUD_ANALYSIS_001 },
			{ url: "/fraud-analysis/v1", code: ErrorCode.ERR_FRAUD_ANALYSIS_001 }],
		errorMessage: biometry,
	},
	authentication: {
		patterns: [{ url: "/token", code: ErrorCode.ERR_TOKEN_001 }],
		errorMessage: authentication,
	},
	balanceInquiryRelease: {
		patterns: [
			{ url: "/balance-inquiry-request", code: ErrorCode.ERR_BALANCE_INQUIRY_001 },
			{ url: "/contracts/eligible", code: ErrorCode.ERR_CONTRACTS_ELIGIBLE_001 },
		],
		errorMessage: balanceInquiryRelease,
	},
	simulation: {
		patterns: [
			{ url: "/partial-simulation", code: ErrorCode.ERR_PARTIAL_SIMULATION_001 },
			{ url: "/total-simulation", code: ErrorCode.ERR_TOTAL_SIMULATION_001 },
		],
		errorMessage: simulation,
	},
	password: {
		patterns: [
			{ url: "/password", code: ErrorCode.ERR_PASSWORD_001 },
			{ url: "/personal/password/validate", code: ErrorCode.ERR_PERSONAL_PASSWORD_VALIDATE_001 },
		],
		errorMessage: password,
	},
	payRegistration: {
		patterns: [
			{ url: "/alreadyRegistration/FGTS/true", code: ErrorCode.ERR_ALREADY_REGISTRATION_001 },
			{ url: "/personal/otp/validate", code: ErrorCode.ERR_PERSONAL_OTP_VALIDATE_001 },
			{ url: "/personal/contacts/phones", code: ErrorCode.ERR_PERSONAL_CONTACTS_PHONES_001 },
			{ url: "/personal/contacts/emails", code: ErrorCode.ERR_PERSONAL_CONTACTS_EMAILS_001 },
			{ url: "/personal/otp", code: ErrorCode.ERR_PERSONAL_OTP_001 },
			{ url: "/personal/address", code: ErrorCode.ERR_PERSONAL_ADDRESS_001 },
			{ url: "/personal/password", code: ErrorCode.ERR_PERSONAL_PASSWORD_001 },
			{ url: "/personal/postal-addresses", code: ErrorCode.ERR_PERSONAL_POSTAL_ADDRESSES_001 },
			{ url: "/personal/filiation", code: ErrorCode.ERR_PERSONAL_FILIATION_001 },
			{ url: "/personal", code: ErrorCode.ERR_PERSONAL_001 },
			{ url: "/full-registration", code: ErrorCode.ERR_FULL_REGISTRATION_001 },
		],
		errorMessage: payRegistration,
	},
	signature: {
		patterns: [
			{ url: "/contracts/signed", code: ErrorCode.ERR_CONTRACTS_SIGNED_001 },
			{ url: "/financial-terms/v1/consents", code: ErrorCode.ERR_FINANCIAL_TERMS_CONSENTS_001 },
		],
		errorMessage: signature,
	},
};

/**
 * Mensagem padrão para quando não foi possível identificar o contexto da URL
 */
export const DEFAULT_ERROR_MESSAGE = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
export const DEFAULT_ERROR_CODE = ErrorCode.ERR_UNKNOWN_001;
